import React from 'react';
export function WhySection() {
  return <>
      <section className="border-b border-navy/10 bg-white px-3 py-4 sm:px-6" data-id="element-159" data-mp="h18whbyucjx2">
        <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="13vt4m45kcu1o">
          <h2 className="text-center font-heading text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-161" data-mp="18ucqk4k5q5u1">
            Stop trying to understand radiology from text alone
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-graphite sm:text-[0.95rem]" data-id="element-162" data-mp="1ikpbhxvvw10p">
            X-ray looks confusing? CT anatomy becomes difficult from one slice to
            another? T1, T2, FLAIR, DWI, windows, densities, signals... what
            exactly should you be looking for? RADIOLOGY VISUAL ATLAS™ gives you
            an organized visual study system to help you understand imaging
            anatomy, compare modalities and recognize important radiologic
            patterns.
          </p>
          <p className="mt-1 text-center font-body text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-163" data-mp="26z68nt136ph">
            See. Compare. Recognize.
          </p>
        </div>
      </section>

      <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-164" data-mp="2do52tg0qaabf">
        <div className="mx-auto max-w-2xl" data-id="element-165" data-mp="28pk7nv0c2gtu">
          <h2 className="text-center font-heading text-[1.05rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-166" data-mp="28qd7ec0vk62h">
            😩 Stop searching through different references for every topic
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-graphite sm:text-[0.95rem]" data-id="element-167" data-mp="31cepsl9oh445">
            You already study radiology. The problem is wasting time jumping
            between textbooks, lecture slides, websites and disconnected images
            just to understand what you're actually seeing. Open the system,
            choose the modality or body region and follow the visual references.
          </p>
          <p className="mt-1 text-center font-body text-[0.72rem] font-extrabold uppercase tracking-wide text-radio sm:text-[0.85rem]" data-id="element-168" data-mp="1bzui346t8p7g">
            Less searching. More structured learning.
          </p>
        </div>
      </section>
    </>;
}